import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export const PasswordInput = React.forwardRef(({ className, "data-testid": testId, ...props }, ref) => {
  const [show, setShow] = useState(false);
  return (
    <div className={cn("relative", className)}>
      <Input
        ref={ref}
        type={show ? "text" : "password"}
        data-testid={testId}
        className="pr-10"
        {...props}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        data-testid={testId ? `${testId}-toggle` : "password-visibility-toggle"}
        aria-label={show ? "Hide password" : "Show password"}
        tabIndex={-1}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-muted-foreground hover:text-foreground transition-colors"
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});

PasswordInput.displayName = "PasswordInput";
